import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileDevPageVideoBtfPrimis from './primis/MobileDevPageVideoBtf';
const MobileDevPageVideoBtf = ({ safety ='off'  })=>{
    const primisOff = useFlag('ads_primis_perf');
    if (primisOff) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageVideoBtfPrimis, {
        safety: safety
    });
};
MobileDevPageVideoBtf.displayName = 'MobileDevPageVideoBtf';
export default MobileDevPageVideoBtf;
